/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkElectricalMeasurement } from '../models/work-electrical-measurement';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';

@Injectable({ providedIn: 'root' })
export class WorkElectricalmeasurementV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `electricalMeasurementsV2ControllerFindOneById()` */
  static readonly ElectricalMeasurementsV2ControllerFindOneByIdPath = '/v2/electricalmeasurement/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkElectricalMeasurement>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalmeasurementV2Service.ElectricalMeasurementsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkElectricalMeasurement>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkElectricalMeasurement> {
    return this.electricalMeasurementsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkElectricalMeasurement>): WorkElectricalMeasurement => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV2ControllerDelete()` */
  static readonly ElectricalMeasurementsV2ControllerDeletePath = '/v2/electricalmeasurement/{id}';

  /**
   * Required permissions: projects:delete, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalmeasurementV2Service.ElectricalMeasurementsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:delete, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.electricalMeasurementsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementsV2ControllerFindAllPaginated()` */
  static readonly ElectricalMeasurementsV2ControllerFindAllPaginatedPath = '/v2/electricalmeasurement';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by electricalMeasurementTypeId query param.
     *           <p>
     *              <b>Format: </b> filter.electricalMeasurementTypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.electricalMeasurementTypeId=$not:$like:John Doe&filter.electricalMeasurementTypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.electricalMeasurementTypeId'?: Array<string>;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkElectricalMeasurement>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'electricalMeasurementTypeId'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalmeasurementV2Service.ElectricalMeasurementsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.electricalMeasurementTypeId', params['filter.electricalMeasurementTypeId'], {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkElectricalMeasurement>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'electricalMeasurementTypeId'?: (string | Array<string>);
        'projectId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by electricalMeasurementTypeId query param.
     *           <p>
     *              <b>Format: </b> filter.electricalMeasurementTypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.electricalMeasurementTypeId=$not:$like:John Doe&filter.electricalMeasurementTypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.electricalMeasurementTypeId'?: Array<string>;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkElectricalMeasurement>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'electricalMeasurementTypeId'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}> {
    return this.electricalMeasurementsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkElectricalMeasurement>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'electricalMeasurementTypeId'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkElectricalMeasurement>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'electricalMeasurementTypeId'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

}
